module.exports = __webpack_public_path__ + "static/media/4.c064f19b.jpg";